import { render, staticRenderFns } from "./MitraPusdokkes.vue?vue&type=template&id=e5d10160"
import script from "./MitraPusdokkes.vue?vue&type=script&lang=js"
export * from "./MitraPusdokkes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports